import EmailLoginForm from "./EmailLoginForm"

export default EmailLoginForm
